import React from 'react';

const DeleteConfirmation = ({ show, handleClose, handleConfirm,
  title = "تأكيد الحذف", 
  msg = "هل أنت متأكد أنك تريد حذف هذا العنصر؟", 
  msgConfirmbtn = "تأكيد الحذف" }) => {
    if (!show.active) {
      return null;
    }
    return (
      <div className="DC-modal">
        <div className="DC-modal-content">
          <h4>{title}</h4>
          <p>{msg}</p>          
          <button onClick={()=> handleConfirm(show.id)}> {msgConfirmbtn} </button>
          <button onClick={handleClose}>إلغاء</button>
        </div>
      </div>
    );
  };
export default DeleteConfirmation;
